<template>
    <label class="container">
        <div class="checkbox-container">
            <input type="checkbox" v-model="remindsMe" />
            <span class="checkmark"></span>
        </div>
        {{ $t("signInUp.remindsMe") }}
    </label>
</template>
<script lang="ts">
import { defineComponent, ref, watch } from "vue";

export default defineComponent({
    props: {
        value: {
            type: Boolean,
            default: false
        }
    },
    emits: ["input"],
    setup(props, { emit }) {
        const remindsMe = ref(props.value);

        watch(remindsMe, () => {
            emit("input", remindsMe.value);
        });

        return {
            remindsMe
        };
    }
});
</script>
<style scoped>
.container {
    margin: 15px 5vw;
    display: flex;
    flex-direction: row;
    align-content: center;
    color: var(--screenTextColor);
}

.container input {
    margin-right: 2vw;
}

/* Hide the browser's default checkbox */
.checkbox-container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
}

.checkbox-container {
    display: block;
    position: relative;
    padding-left: 35px;
    margin-bottom: 12px;
    cursor: pointer;
    font-size: 22px;
    user-select: none;
}

/* Create a custom checkbox */
.checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 25px;
    width: 25px;
    background-color: var(--secondary);
    box-shadow: 2px 3px 5px 0px rgb(150 150 150 / 50%);
    border-radius: 5px;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
    content: "";
    position: absolute;
    display: none;
}

/* Show the checkmark when checked */
.checkbox-container input:checked ~ .checkmark:after {
    display: block;
}

/* Style the checkmark/indicator */
.checkbox-container .checkmark:after {
    left: 9px;
    top: 5px;
    width: 5px;
    height: 10px;
    border: solid var(--buttonTextColor);
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
}
</style>
